import ContentsTypes from "@shared/enums/contentsTypes";
import OfferingCardPreview from "@project/components/OfferingCard/OfferingCardPreview";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const OfferingCard = {
    label: "Offre",
    type: ContentsCustomTypes.OFFERING_CARD,
    Preview: OfferingCardPreview,
    editionModal: true,
    icon: "address-card",
    editionModalPosition: "top",
    children: [
        {
            label: "Variant",
            key: "variant",
            type: ContentsTypes.SELECT,
            options: [
                {
                    label: "Mise en avant",
                    value: "highlighted",
                },
                {
                    label: "Défaut",
                    value: "default",
                },
            ],
            value: "default",
        },
        {
            label: "Taille",
            key: "size",
            type: ContentsTypes.SELECT,
            options: [
                { label: "moyen", value: "M" },
                { label: "grand", value: "L" },
            ],
            value: "L",
        },
        {
            label: "Couleur",
            key: "barColor",
            type: ContentsTypes.COLOR,
            value: "#0CFFC6",
        },
        {
            label: "Sur-titre",
            key: "surtitle",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.SHORT_TEXT,
            value: "",
        },
        {
            label: "Caractéristiques",
            key: "features",
            type: ContentsTypes.TEXT,
            value: "",
        },
        {
            label: "Masquer les caractéristiques",
            key: "hideFeatures",
            type: ContentsTypes.CHECKBOX,
            value: "",
        },
        {
            label: "Avantage inclus",
            key: "plusFeature",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Icône avantage inclus",
            key: "plusFeatureIcon",
            type: ContentsTypes.ICON,
            value: "",
        },
        {
            label: "Prix",
            key: "price",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Détails du prix",
            key: "priceDetails",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Bouton",
            key: "button",
            type: ContentsTypes.LINK,
            value: "",
        },
        {
            label: "Icône",
            key: "iconButton",
            type: ContentsTypes.ICON,
            value: "",
        },
    ],
};
